import { render, staticRenderFns } from "./LockCard.vue?vue&type=template&id=4cdb2133&"
import script from "./LockCard.vue?vue&type=script&lang=js&"
export * from "./LockCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports